const STEP_SUBMITTED = 'step_submitted';
const STEPS_RESET = 'steps_reset';

const initialState = {};

export const assertionStepSubmittedAction = step => dispatch => {
  dispatch(stepSubmitted(step));
  return Promise.resolve('Step Submitted Successfully!');
};

export const stepsSubmittedResetAction = dispatch => {
  dispatch({
    type: STEPS_RESET
  });
};

const stepSubmitted = step => ({
  type: STEP_SUBMITTED,
  step
});

const assertionStepSubmittedReducer = (state = initialState, action) => {
  switch (action.type) {
    case STEP_SUBMITTED:
      return { ...state, ...action.step };
    case STEPS_RESET:
      return {};
    default:
      return state;
  }
};

export default assertionStepSubmittedReducer;
